import type { LoginInfoThinModelMaybe } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const PlusSignUpQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    model?: LoginInfoThinModelMaybe;
}>({
    isOpen: false
});

export default function usePlusSignUpQuickView() {
    return useMediatorState(PlusSignUpQuickViewAtom);
}
